const NEWS = {
    ALL_BRANDS: '1',
    ALL_CATEGORIES: '2',
    ALL_TYPES: '3',
    DONE_TYPING_INTERVAL: 500,
    SPACE: ' ',
    SPACE_REPLACEMENT: '-',
    APOSTROPHE: "'"
};
let NewsArticleComponent = {
    newsArticleComponent: {},
    listCardComponent: {},
    paginationControls: {},
    controls: {
        brandFilter: {},
        categoryFilter: {},
        typeFilter: {},
        newsSearch: {}
    },
    pageHeading: {},
    documentTitle: {},
    selectedScopeName: '',
    selectedBrandName: '',
    selectedDevelopmentName: '',
    selectedSourceName: '',
    selectedCategoryName: '',
    selectedTypeName: '',
    restSuccess: '',
    restError: '',
    queryString: '',
    filtersNoMatch: '',
    searchFiltersPlaceholder: '',
    typingTimer: '',
    init: function(newsArticleComponent) {
        this.newsArticleComponent = newsArticleComponent;

        // get the news filter controls
        this.controls.brandFilter = document.getElementById('news-filter--brands');
        this.controls.brandFilter.addEventListener('change', (e) => {
            this.updateFilter(e.target, 'currentBrand');
        });
        this.controls.categoryFilter = document.getElementById('news-filter--categories');
        this.controls.categoryFilter.addEventListener('change', (e) => {
            this.updateFilter(e.target, 'currentCategory');
        });
        this.controls.typeFilter = document.getElementById('news-filter--types');
        this.controls.typeFilter.addEventListener('change', (e) => {
            this.updateFilter(e.target, 'currentType');
        });
        this.controls.newsSearch = document.getElementById('news-filter--search');
        this.controls.newsSearch.addEventListener('keyup', (e) => {
            clearTimeout(this.typingTimer);
    
            if (e.key !== 'Backspace') {
                if (e.target.value.length > 3) {
                    this.typingTimer = setTimeout(this.doneTyping, NEWS.DONE_TYPING_INTERVAL);
                }
            } else {
                if (e.target.value.length > 3) {
                    this.typingTimer = setTimeout(this.doneTyping, NEWS.DONE_TYPING_INTERVAL);
                }
                if (this.controls.newsSearch.value === '') {
                    this.typingTimer = setTimeout(this.doneTyping, NEWS.DONE_TYPING_INTERVAL);
                }
            }
        });

        // get the list card component (there can only be one on a page)
        this.listCardComponent = document.getElementById('list-card-component');
        this.paginationControls = document.getElementById('pagination-wrapper');
        PaginatedListComponent.init(this.listCardComponent, this.paginationControls, this.showItems);

        this.getHiddenFieldValue('restSuccess', '.rest-message--success', false);
        this.getHiddenFieldValue('restError', '.rest-message--error', false);

        this.getInitialFilterState().then((state) => {

            let searchResultsNoMatchField = document.querySelector('.search-results-no-matches');
            if (searchResultsNoMatchField) {
                this.filtersNoMatch = `<div class="loader-title">${searchResultsNoMatchField.value}</div>`;
            }
    
            let searchFiltersPlaceholder = document.querySelector('.search-placeholder');
            if (searchFiltersPlaceholder) {
                this.searchFiltersPlaceholder = searchFiltersPlaceholder.value;
            }
            // Document Title
            let documentTitle = document.querySelector('TITLE');
            if (documentTitle) {
                this.documentTitle = documentTitle;
            }
    
            // Page Heading
            let pageHeading = document.querySelector('.page-title H1');
            if (pageHeading) {
                this.pageHeading = pageHeading;
            }

            this.showItems(PAGINATION.FIRST_PAGE).then( () => {
                history.replaceState(PaginatedListComponent.state, '', PaginatedListComponent.getURL());
            });
        });
    },
    getHiddenFieldValue: function(fieldName, querySelector, isStateField) {
        let field = document.querySelector(querySelector); 
        if (field) {
            if (isStateField) {
                PaginatedListComponent.state[fieldName] = field.value;
            } else {
                this[fieldName] = field.value;
            }
        }
    },
    getData: async function(useSavedState) {
        let data = {};
        if (useSavedState) {
            data.data = {
                newsItems: PaginatedListComponent.getQuerySet(),
                noOfItemsPerPage: PaginatedListComponent.getNumberOfItemsPerPage(),
                selectedPage: PaginatedListComponent.getPage(),
                tooltips: PaginatedListComponent.getButtonTooltips(),
                totalNoOfItems: PaginatedListComponent.getTotalNumberOfItems(),
                newsFilters: PaginatedListComponent.state.filtersQuerySet,    
                currentBrand: PaginatedListComponent.state.currentBrand,
                currentCategory: PaginatedListComponent.state.currentCategory,
                currentType: PaginatedListComponent.state.currentType,
                keyword: PaginatedListComponent.state.currentSearch
            };
        } else {
            let URL = `${APIPrefix.get()}/search_api/news/news?page=${PaginatedListComponent.getPage()}&noOfItemsPerPage=${PaginatedListComponent.getNumberOfItemsPerPage()}&selectedNews=${PaginatedListComponent.state.currentBrand}&selectedCategory=${PaginatedListComponent.state.currentCategory}&selectedType=${PaginatedListComponent.state.currentType}&queryString=${PaginatedListComponent.state.currentSearch}`;
            data = APIUtils.getComponentData(this.listCardComponent, URL, this.restSuccess, this.restError);
        }
        return data;
    },
    showItems: async function (page, useSavedState) {

        return new Promise((resolve) => {

            PaginatedListComponent.setPage(page);
            NewsArticleComponent.getData(useSavedState).then((response) => {
                let data = response.data;
                PaginatedListComponent.setPage(data.selectedPage);
                PaginatedListComponent.setTotalNumberOfItems(data.totalNoOfItems);
                PaginatedListComponent.setQuerySet(data.newsItems);
                PaginatedListComponent.setButtonTooltips(data.tooltips);

                PaginatedListComponent.state.filtersQuerySet = data.newsFilters;    
                PaginatedListComponent.state.currentBrand = data.currentBrand;
                PaginatedListComponent.state.currentCategory = data.currentCategory;
                PaginatedListComponent.state.currentType = data.currentType;
                PaginatedListComponent.state.currentSearch = data.keyword;
    
                if (data.newsItems !== undefined) {
                    NewsArticleComponent.buildListCardComponent();
                } else {
                    NewsArticleComponent.listCardComponent.innerHTML = this.filtersNoMatch;
                }
                NewsArticleComponent.getSelectedFilterNames();
                NewsArticleComponent.setDocumentTitle();
                NewsArticleComponent.setNewsPageHeading();
                PaginatedListComponent.setQueryString(NewsArticleComponent.getPageURL());
                NewsArticleComponent.buildNewsFilters();
                PaginatedListComponent.adjustListCardComponentHeight();
                PaginatedListComponent.clearControls();
                if (PaginatedListComponent.getNumberOfPages() > 1) {
                    PaginatedListComponent.pageButtons();
                }

                resolve(response.data);
            }).catch(() => {
                // Re-enable dropdowns even if there's an error
                this.setDropdownsDisabled(false);
            });

        });

    },
    updateFilter: function(field, filterName) {
        let selected = field[field.selectedIndex].value;
        if (selected !== PaginatedListComponent.state[filterName]) {
            PaginatedListComponent.state[filterName] = selected;
            this.updateNewsItems();
        }
    },
    updateNewsItems: function () {
        // Disable dropdowns
        this.setDropdownsDisabled(true);
        this.showItems(PAGINATION.FIRST_PAGE).then((res) => {
            history.pushState(PaginatedListComponent.state, '', PaginatedListComponent.getURL());
            // Re-enable dropdowns
            this.setDropdownsDisabled(false);
        }).catch(() => {
            // Re-enable dropdowns even if there's an error
            this.setDropdownsDisabled(false);
        });
    },
    setDropdownsDisabled: function(disabled) {
        this.controls.brandFilter.disabled = disabled;
        this.controls.categoryFilter.disabled = disabled;
        this.controls.typeFilter.disabled = disabled;
    },
    doneTyping: function () {
        PaginatedListComponent.state.currentSearch = NewsArticleComponent.controls.newsSearch.value;
        NewsArticleComponent.updateNewsItems();
    },
    buildListCardComponent: function() {
        let items = PaginatedListComponent.getQuerySet();
        let listHTML = '';
        items.forEach((item) => {
            listHTML = `${listHTML}${this.buildNewsCard(item)}`;
        });
        this.listCardComponent.innerHTML = listHTML;
    },
    buildNewsCard: function(item) {
        return `
            <div class="news-article-item">
                <a href="${item.linkHref}"><img class="img--responsive" width="385" alt="${item.title}" src="${item.imageUrl}"></a>
                <span class="article-tag">${item.contentType}</span>
                <div class="news-article-content">
                    <h3><a href="${item.linkHref}">${item.title}</a></h3>
                    <p>${item.date}</p>
                    <div>${item.description}</div>
                    <a class="button button--link" title="${item.linkTooltip}" href="${item.linkHref}">Read More</a>
                </div>
            </div>
        `;
    },
    buildNewsFilters: function() {
        let filters = PaginatedListComponent.state.filtersQuerySet;
        NewsArticleComponent.controls.brandFilter.innerHTML = NewsArticleComponent.buildBrandFilter(filters);
        NewsArticleComponent.controls.categoryFilter.innerHTML = NewsArticleComponent.buildCategoryFilter(filters);
        NewsArticleComponent.controls.typeFilter.innerHTML = NewsArticleComponent.buildTypeFilter(filters);
    
        //Placeholder
        NewsArticleComponent.controls.newsSearch.setAttribute('placeholder', NewsArticleComponent.searchFiltersPlaceholder);
        NewsArticleComponent.controls.newsSearch.value = PaginatedListComponent.state.currentSearch;
    },
    buildBrandFilter(filters) {
        let filterHTML = '';

        filters.all.forEach((filter) => {
            filterHTML = `${filterHTML}<option value="${filter.id}" ${PaginatedListComponent.state.currentBrand === filter.id ? 'selected' : ''}>${filter.opt}</option>`;
        });

        if (filters.brands.length) {
            let brandFilterHTML = NewsArticleComponent.buildFilterOptionsHTML(filters.brands, 'currentBrand');
            filterHTML = `${filterHTML}<optgroup label="${filters.optGroupBrands}">${brandFilterHTML}</optgroup>`;
        }

        if (filters.developments.length) {
            let developmentFilterHTML = NewsArticleComponent.buildFilterOptionsHTML(filters.developments, 'currentBrand');
            filterHTML = `${filterHTML}<optgroup label="${filters.optGroupDevelopments}">${developmentFilterHTML}</optgroup>`;
        }

        return filterHTML;
    },

    buildCategoryFilter(filters) {
        return NewsArticleComponent.buildFilterOptionsHTML(filters.categories, 'currentCategory');
    },

    buildTypeFilter(filters) {
        return NewsArticleComponent.buildFilterOptionsHTML(filters.types, 'currentType');
    },

    buildFilterOptionsHTML(filters, currentStateField) {
        let filterHTML = '';
        if (filters.length) {
            filters.forEach((filter) => {
                filterHTML = `${filterHTML}<option value="${filter.id}" ${PaginatedListComponent.state[currentStateField] === filter.id ? 'selected' : ''}>${filter.opt}</option>`;
            });
        }
        return filterHTML;
    },

    getSelectedFilterNames: function() {

        let filters = PaginatedListComponent.state.filtersQuerySet;

        let selectedScope = [];
        if (PaginatedListComponent.state.currentBrand !== NEWS.ALL_BRANDS) {
            selectedScope = filters.all.filter((scope) => scope.id === PaginatedListComponent.state.currentBrand);
        }
        NewsArticleComponent.selectedScopeName = selectedScope.length ? selectedScope[0].opt : '';
        let selectedBrand = filters.brands.filter((brand) => brand.id === PaginatedListComponent.state.currentBrand);
        NewsArticleComponent.selectedBrandName = selectedBrand.length ? selectedBrand[0].opt : '';

        let selectedDevelopment = filters.developments.filter((development) => development.id === PaginatedListComponent.state.currentBrand);
        NewsArticleComponent.selectedDevelopmentName = selectedDevelopment.length ? selectedDevelopment[0].opt : '';
        NewsArticleComponent.selectedSourceName = `${NewsArticleComponent.selectedScopeName}${NewsArticleComponent.selectedBrandName}${NewsArticleComponent.selectedDevelopmentName}`;

        let selectedCategory = [];
        if (PaginatedListComponent.state.currentCategory !== NEWS.ALL_CATEGORIES) {
            selectedCategory = filters.categories.filter((category) => category.id === PaginatedListComponent.state.currentCategory );
        }
        NewsArticleComponent.selectedCategoryName = selectedCategory.length ? selectedCategory[0].opt : '';

        let selectedType = []; 
        if (PaginatedListComponent.state.currentType !== NEWS.ALL_TYPES) {
            selectedType = filters.types.filter((type) => type.id === PaginatedListComponent.state.currentType);
        }
        NewsArticleComponent.selectedTypeName = selectedType.length ? selectedType[0].opt : '';

    },

    setNewsPageHeading: function() {

        let pageHeadingText = 'Latest News';

        if (NewsArticleComponent.selectedSourceName.length) {
            pageHeadingText = `${pageHeadingText} from ${NewsArticleComponent.selectedSourceName}`;
        }

        if (NewsArticleComponent.selectedCategoryName.length) {
            pageHeadingText = `${pageHeadingText} - ${NewsArticleComponent.selectedCategoryName}`;
        }

        if (NewsArticleComponent.selectedTypeName.length) {
            pageHeadingText = `${pageHeadingText} ${NewsArticleComponent.selectedTypeName.toLowerCase()}`;
        }

        NewsArticleComponent.pageHeading.innerHTML = pageHeadingText;
        
    },
    setDocumentTitle: function() {
        let documentTitleText = 'Latest News';
        let documentTitleTextSuffix = 'Berkeley Group'; 

        if (NewsArticleComponent.selectedSourceName.length) {
            documentTitleText = `${documentTitleText} from ${NewsArticleComponent.selectedSourceName}`;
        }

        if (NewsArticleComponent.selectedCategoryName.length) {
            documentTitleText = `${documentTitleText} - ${NewsArticleComponent.selectedCategoryName}`;
        }

        if (NewsArticleComponent.selectedTypeName.length) {
            documentTitleText = `${documentTitleText} ${NewsArticleComponent.selectedTypeName}`;
        }

        NewsArticleComponent.documentTitle.innerHTML = `${documentTitleText} | ${documentTitleTextSuffix}`;
        
    },

    getPageURL: function() {

        let params = [];

        if (NewsArticleComponent.selectedScopeName.length) {
            params.push(`scope=${NewsArticleComponent.selectedScopeName}`);
        }

        if (NewsArticleComponent.selectedBrandName.length) {
            params.push(`brand=${NewsArticleComponent.selectedBrandName}`);
        }

        if (NewsArticleComponent.selectedDevelopmentName.length) {
            params.push(`development=${NewsArticleComponent.selectedDevelopmentName}`);
        }

        if (NewsArticleComponent.selectedCategoryName.length) {
            params.push(`category=${NewsArticleComponent.selectedCategoryName}`);
        }

        if (NewsArticleComponent.selectedTypeName.length) {
            params.push(`type=${NewsArticleComponent.selectedTypeName}`);
        }

        if (PaginatedListComponent.state.currentSearch.length) {
            params.push(`news-search=${PaginatedListComponent.state.currentSearch}`);
        }

        let queryString = params.join('&');

        if (queryString.length) {
            queryString = `?${queryString.replaceAll(NEWS.SPACE, NEWS.SPACE_REPLACEMENT).replaceAll(NEWS.APOSTROPHE,'')}`;
        }
        return queryString;
    },

    getFilterData: async function() {
        // get the filter data
        let URL = `${APIPrefix.get()}/search_api/news/newsAllFilters`;
        let data = APIUtils.getData(URL);
        return data;
    },
    getInitialFilterState: async function() {
        return new Promise((resolve) => {
            PaginatedListComponent.state.currentBrand = NEWS.ALL_BRANDS;
            PaginatedListComponent.state.currentCategory = NEWS.ALL_CATEGORIES;
            PaginatedListComponent.state.currentType = NEWS.ALL_TYPES;
            PaginatedListComponent.state.currentSearch = '';

            // check for server side brand parameter
            let brandField = document.querySelector('.redirect-page');
            if (brandField) {
                PaginatedListComponent.state.currentBrand = brandField.value;
            }

            // check for url Search Parameters
            let paramsString = window.location.search;
            if (paramsString.length) {
                this.getFilterData().then((response) => {
                    let filters = response.data;
                    let searchParams = new URLSearchParams(paramsString.toLowerCase());
                    NewsArticleComponent.checkSearchParam(searchParams, 'brand', 'currentBrand', filters.brands, NEWS.ALL_BRANDS);
                    NewsArticleComponent.checkSearchParam(searchParams, 'development', 'currentBrand', filters.developments, NEWS.ALL_BRANDS);
                    NewsArticleComponent.checkSearchParam(searchParams, 'scope', 'currentBrand', filters.all, NEWS.ALL_BRANDS);
                    NewsArticleComponent.checkSearchParam(searchParams, 'category', 'currentCategory', filters.categories, NEWS.ALL_CATEGORIES);
                    NewsArticleComponent.checkSearchParam(searchParams, 'type', 'currentType', filters.types, NEWS.ALL_TYPES);
                    if (searchParams.has('news-search')) {
                        PaginatedListComponent.state.currentSearch = searchParams.get('news-search').replaceAll(NEWS.SPACE_REPLACEMENT, NEWS.SPACE);
                    }
                    resolve(PaginatedListComponent.state);
                });
            } else {
                // return the default state
                resolve(PaginatedListComponent.state);
            }
        });
    },
    checkSearchParam: function(searchParams, key, stateKey, options, defaultValue) {
        if (searchParams.has(key)) {
            let value = searchParams.get(key).replaceAll(NEWS.SPACE_REPLACEMENT, NEWS.SPACE);
            let selected = options.filter((option) => value === option.opt.toLowerCase().replaceAll(NEWS.APOSTROPHE,'').replaceAll(NEWS.SPACE_REPLACEMENT, NEWS.SPACE));
            PaginatedListComponent.state[stateKey] = selected.length ? selected[0].id : defaultValue;
        }
    }

};

// Check for News Article component initialise if we have one 
document.addEventListener("DOMContentLoaded", function () {
    const newsArticleComponent = document.querySelector('.news-component');
    if (newsArticleComponent) {
        NewsArticleComponent.init(newsArticleComponent);
    }
});
